import { TSelectOption } from 'types';

export const VESSEL_TYPE_LIST: TSelectOption<number>[] = [
  { label: 'Pelagic', value: 2 },
  { label: 'Freezing trawler', value: 4 },
  { label: 'Long liner', value: 5 },
  { label: 'Trawler', value: 3 },
  { label: 'Coast', value: 10 },
  { label: 'Tuna', value: 9 },
  { label: 'Krill', value: 8 },
  { label: 'Crabs and shellfish', value: 6 },
  { label: 'Coast guard', value: 14 },
  { label: 'Cargo', value: 11 },
  { label: 'Research vessel', value: 13 },
  { label: 'Processing vessel', value: 12 },
  { label: 'Oil tanker', value: 21 },
  { label: 'Offshore', value: 25 },
  { label: 'Icebreaker', value: 22 },
  { label: 'Newbuildings (FF)', value: 23 }
  // { label: 'Seals', value: 7 },
];
